import React from "react";
import ModalDiskon from "../../../components/ModalDiskon/ModalDiskon";
import ModalMutasiStok from "../../../components/ModalMutasiStok/ModalMutasiStok";
import ModalPopup from "../../../components/ModalPopup/ModalPopup";
import { useTransaksiStore } from "../../../stores/transaksiStore";

type TransaksiModalsProps = {
    isModalMutasiOpen: boolean;
    isOpenPopup: boolean;
    namaToko?: string;
    onCloseMutasi: () => void;
    onClosePopup: () => void;
    trialFlag10?: 0 | 1;
    trialTempo?: string | null;
    ukmId?: number;
};

const TransaksiModals = ({
    isModalMutasiOpen,
    isOpenPopup,
    namaToko,
    onCloseMutasi,
    onClosePopup,
    trialFlag10,
    trialTempo,
    ukmId,
}: TransaksiModalsProps) => {
    const isOpenModalTransaksi = useTransaksiStore(
        (s) => s.isOpenModalTransaksi,
    );
    return (
        <>
            {isOpenModalTransaksi && <ModalDiskon />}
            {isModalMutasiOpen && (
                <ModalMutasiStok
                    open={isModalMutasiOpen}
                    onClose={onCloseMutasi}
                />
            )}
            {isOpenPopup && (
                <ModalPopup
                    dataUkm={{
                        id: ukmId || 0,
                        nama: namaToko || "",
                        trialFlag10: trialFlag10 || 0,
                        trialTempo: trialTempo || null,
                    }}
                    open={isOpenPopup}
                    onClose={onClosePopup}
                />
            )}
        </>
    );
};

export default TransaksiModals;
